module.exports = __webpack_public_path__ + "img/logo_original_samtek.43fb22fc.png";